import React from "react";
import { ThreeCircles } from "react-loader-spinner";

const LoadingSpinner = () => {
  return (
    <div style={styles.container}>
      <ThreeCircles
        visible={true}
        height={window.innerWidth < 480 ? 64 : window.innerWidth < 768 ? 80 : 100}
        width={window.innerWidth < 480 ? 64 : window.innerWidth < 768 ? 80 : 100}
        color="#0D1345"
        strokeWidth="5"
        animationDuration="1"
        ariaLabel="rotating-lines-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  );
};

const styles = {
  container: {
    position: "fixed",
    inset: 0,
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    display: "flex",
    justifyContent: "center", // Centers horizontally
    alignItems: "center", // Centers vertically within its own size
    width: "100%",
    height: "100%",
    backgroundColor: "transparent", // Optional: background color
    zIndex: 100,
  },
};

export default LoadingSpinner;
